import classes from "./MeetingGraph.module.css";
import meeting from "../../../../store/Vienna/planek_v2_bez_nabytku_e.png"
import backlogo from "../../../../store/back.jpg";
import {useEffect, useState} from "react";
import axios from "axios";
import {path} from "../../../../routes";
import GraphRecord from "./GraphRecord";

const MeetingGraph = (props) => {

    const [meetings, setMeetings] = useState([]);
    const [loading, setLoading] = useState(false);

    const [opalA,setOpalA] = useState([]);
    const [opalB, setOpalB] = useState([]);
    const [opalC, setOpalC] = useState([]);
    const [opalD, setOpalD] = useState([]);
    const [smaragd, setSmaragd] = useState([]);
    const [topaz, setTopaz] = useState([]);
    const [safir, setSafir] = useState([]);

    const sort_handler = (field) => {
        setOpalA([])
        setOpalB([])
        setOpalC([])
        setOpalD([])
        setSafir([])
        setSmaragd([])
        setTopaz([])
        for (let i = 0; i < field.length; i++) {
            let tmp = field[i].room
            if (tmp == "OPAL A"){setOpalA(field[i])}
            if (tmp == "OPAL B"){setOpalB(field[i])}
            if (tmp == "OPAL C"){setOpalC(field[i])}
            if (tmp == "OPAL D"){setOpalD(field[i])}
            if (tmp == "SMARAGD"){setSmaragd(field[i])}
            if (tmp == "SAFIR"){setSafir(field[i])}
            if (tmp == "TOPAZ"){setTopaz(field[i])}
        }
    }
    const fetch_meetings = async () =>{
        setLoading(true)
        const dt = new Date
        const date = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`
        const actTime = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}T${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}:${String(dt.getSeconds() ).padStart(2, "0")}`;

        const response = await axios.get(`${path}/getRecordsNowV2?orgID=62BDEE7F-9CE9-41BE-A80C-EF69F045D56C&day=${actTime}`);
        setMeetings(response.data)
        sort_handler(response.data)
        if (response.data.length == 0) {props.reset()}
        setLoading(false)
    }

    const back_handler = () =>{
        props.changeStep(1)
    }

    useEffect(() => {
        fetch_meetings()
    }, []);

    useEffect(() => {
        const intervalfetchmeeting = setInterval(() => {
            fetch_meetings()
        }, 20 * 1000);
        return () => {
            clearInterval(intervalfetchmeeting);
        };
    }, []);

    return <div className={classes.cont}>
        <div className={classes.header}>Meetings & events
           </div>
        <img className={classes.contimg} src={meeting} alt="meeting"/>
        {opalA.length != 0 && <div className={classes.opalA}><GraphRecord data={opalA}/></div>}
        {opalB.length != 0 && <div className={classes.opalB}><GraphRecord data={opalB}/></div>}
        {opalC.length != 0 && <div className={classes.opalC}><GraphRecord data={opalC}/></div>}
        {opalD.length != 0 && <div className={classes.opalD}><GraphRecord data={opalD}/></div>}
        {smaragd.length != 0 && <div className={classes.smaragd}><GraphRecord data={smaragd}/></div>}
        {safir.length != 0 && <div className={classes.safir}><GraphRecord data={safir}/></div>}
        {topaz.length != 0 && <div className={classes.topaz}><GraphRecord data={topaz}/></div>}

    </div>
}
export default MeetingGraph;